import { State } from '../state';

export const UsersSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    users: (state: State) => state.Users,
};
